import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Spacer,
  Text,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Link,
  Switch,
  DarkMode,
  Select,
  color,
  IconButton,
  Checkbox,
} from "@chakra-ui/react";

// Images

// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GradientBorder from "components/GradientBorder/GradientBorder";

import { FiEye, FiEyeOff } from "react-icons/fi";
import useApiReq from "variables/apireq";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useLoader } from "components/Loader/loader";
import { useToast } from "@chakra-ui/react";

function CreateAdvertiser() {
  const titleColor = "white";
  const textColor = "gray.400";
  const history = useHistory();
  const [formData, setFormData] = useState({});
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const { setIsLoading, isLoading } = useLoader();
  const toast = useToast({
    position: "top",
  });

  useEffect(() => {
    if (error) {
      toast({
        title: "Error",
        description: error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error, toast]);

  // Early return after all hooks are called
  if (isLoading) {
    return null;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    console.log(formData);
  };
  const handleEmptyFields = () => {
    setFormData((prev) =>
      Object.fromEntries(
        Object.entries(prev).filter(([_, value]) => value && value.length > 0)
      )
    );
  };
  const createAdvertiser = async (data) => {
    setError(null);
    setIsLoading(true);
    try {
      const res = await useApiReq({
        method: "POST",
        url: "advertiser/create/",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: data,
      });
      if (res.error) {
        setError(res.error?.message || res.error);
      } else {
        setFormData({});
        toast({
          title: "Advertiser Created",
          description: "Advertiser has been created successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        history.push(
          `/${localStorage.getItem("group").toLowerCase()}/advertiser/list`
        );
      }
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      user: {
        username: formData.advertiserName,
        email: formData.advertiserEmail,
        password: formData.password,
      },
      phone_number: formData.phoneNumber,
      address: formData.contactInfo,
    };
    createAdvertiser(data);
  };
  const handleShow = () => {
    console.log(show);
    setShow(!show);
  };

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }} mx="auto">
      <Grid templateColumns={{ sm: "1fr", lg: "60% 38%" }}>
        {/* Form */}
        <Card p="16px">
          <CardHeader>
            <Flex
              justify="space-between"
              align="center"
              minHeight="60px"
              w="100%"
            >
              <Text fontSize="lg" color="#fff" fontWeight="bold">
                Advertiser Create
              </Text>
            </Flex>
          </CardHeader>
          <CardBody>
            <Flex
              justify="space-between"
              align="center"
              minHeight="60px"
              w="100%"
            >
              <GradientBorder
                p="2px"
                ml={{ base: "0px", lg: "24px" }}
                w="100%"
                me={{ base: "none", lg: "30px", xl: "none" }}
                background="transparent"
                boxShadow="0px 0px 2px 2px rgba(255,255,255,0.1)"
                borderRadius="30px"
              >
                <Flex
                  background="transparent"
                  borderRadius="30px"
                  direction="column"
                  p="40px"
                  minW={{ base: "unset", md: "430px", xl: "450px" }}
                  w="100%"
                  mx={{ base: "0px" }}
                  bg={{
                    base: "rgba(19,21,56,.5)",
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    <FormControl>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Advertiser Name
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          placeholder="Advertiser Name"
                          name="advertiserName"
                          value={formData.advertiserName}
                          onChange={handleChange}
                        />
                      </GradientBorder>
                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Advertiser Email
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="email"
                          placeholder="Advertiser Email"
                          name="advertiserEmail"
                          value={formData.advertiserEmail}
                          onChange={handleChange}
                        />
                      </GradientBorder>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Password
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type={show ? "text" : "password"}
                          placeholder="Password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          _focus={{
                            zIndex: 1,
                          }}
                        />
                        <IconButton
                          aria-label="show"
                          icon={
                            !show ? <Icon as={FiEyeOff} /> : <Icon as={FiEye} />
                          }
                          size="md"
                          mt="0px"
                          color={"white"}
                          colorScheme="brand"
                          variant="plain"
                          _hover={{
                            color: "brand.500",
                          }}
                          onClick={handleShow}
                          position={"absolute"}
                          right="10px"
                          zIndex={2}
                        />
                      </GradientBorder>

                      <FormLabel
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Phone Number
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          placeholder="01777777777"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                        />
                      </GradientBorder>
                      <FormLabel
                        marginLeft={"4px"}
                        color={titleColor}
                        ms="4px"
                        fontSize="sm"
                        fontWeight="normal"
                      >
                        Contact Info
                      </FormLabel>
                      <GradientBorder
                        mb="24px"
                        h="50px"
                        w={{ base: "100%", lg: "100%" }}
                        borderRadius="20px"
                      >
                        <Input
                          color={titleColor}
                          bg={{
                            base: "rgb(19,21,54)",
                          }}
                          border="transparent"
                          borderRadius="20px"
                          fontSize="sm"
                          size="lg"
                          w={{ base: "100%", lg: "100%" }}
                          maxW="100%"
                          h="46px"
                          type="text"
                          placeholder="Contact info"
                          name="contactInfo"
                          value={formData.contactInfo}
                          onChange={handleChange}
                        />
                      </GradientBorder>

                      <Button
                        variant="brand"
                        fontSize="18px"
                        type="submit"
                        w={{ base: "100%", lg: "100%" }}
                        maxW="100%"
                        h="45px"
                        mb="20px"
                        mt="20px"
                      >
                        Submit
                      </Button>
                    </FormControl>
                  </form>
                </Flex>
              </GradientBorder>
            </Flex>
          </CardBody>
        </Card>

        {/* Preview */}
        <Card
          p="22px"
          my={{ sm: "24px", lg: "0px" }}
          ms={{ sm: "0px", lg: "24px" }}
        >
          <Flex direction="column">
            <CardHeader py="12px">
              <Text color="#fff" fontSize="lg" fontWeight="bold">
                Preview
              </Text>
            </CardHeader>
            <CardBody>
              <Flex direction="column" w="100%">
                {/* {billingData.map((row) => {
                  return (
                    <BillingRow
                      Order={row.Order}
                      campaign={row.campaign}
                      publisher={row.publisher}
                    />
                  );
                })} */}
                {Object.entries(formData)
                  .filter(([_, value]) => value && value.length > 0)
                  .map(([key, value]) => {
                    const formatKey = key
                      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase
                      .replace(/\b\w/g, (c) => c.toUpperCase());

                    if (key === "password") {
                      return (
                        <Text
                          key={key}
                          color="#fff"
                          fontSize="lg"
                          mb="4px"
                          fontWeight="500"
                        >
                          <span>{formatKey}</span>:{" "}
                          {show ? value : value.replace(/./g, "*")}
                        </Text>
                      );
                    }

                    return (
                      <Text
                        key={key}
                        color="#fff"
                        fontSize="lg"
                        mb="4px"
                        fontWeight="500"
                      >
                        <span>{formatKey}</span>: {value}
                      </Text>
                    );
                  })}
              </Flex>
            </CardBody>
          </Flex>
        </Card>
      </Grid>
    </Flex>
  );
}

export default CreateAdvertiser;
